(function ($) {
  "use strict";

  jQuery(document).ready(function(){

    /*--
    Menu Sticky
-----------------------------------*/
    var windows = $(window);
    var sticky = $('.header-sticky');

    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 300) {
        sticky.removeClass('is-sticky');
      }else{
        sticky.addClass('is-sticky');
      }
    });

    /*--
    Mobile Menu
------------------------*/
    var menuNav = $('nav.main-navigation');
    menuNav.meanmenu({
      meanScreenWidth: '991',
      meanMenuContainer: '.mobile-menu',
      meanMenuClose: '<span class="menu-close"></span>',
      meanMenuOpen: '<span class="menu-bar"></span>',
      meanRevealPosition: 'right',
      meanMenuCloseSize: '0',
    });

    /*--
   Sidebar Search Active
-----------------------------*/
    function sidebarSearch() {
      var searchTrigger = $('.trigger-search'),
          endTriggersearch = $('button.search-close'),
          container = $('.main-search-active');

      searchTrigger.on('click', function() {
        container.addClass('inside');
      });

      endTriggersearch.on('click', function() {
        container.removeClass('inside');
      });

    };
    sidebarSearch();



    /*-- Brand Slider --*/
    var blogSlider = $('.blog-image-slider');
    blogSlider.slick({
      arrows: true,
      autoplay: false,
      dots: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScoll: 1,
      prevArrow: '<button type="button" class="slick-prev"> <i class="icon-arrow-left"></i> </button>',
      nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
    });

    /*--
    vertical-product-active
--------------------------------------*/
    $('.vartical-product-active').slick({
      slidesToShow: 4,
      autoplay: false,
      vertical:true,
      verticalSwiping:true,
      slidesToScroll: 1,
      prevArrow:'<i class="icon-arrow-top arrow-prv"></i>',
      nextArrow:'<i class="icon-arrow-bottom arrow-next"></i>',
      button:false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        { breakpoint: 991,
         settings: {
           slidesToShow: 3,
           vertical:false,
         }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            vertical:false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            vertical:false,
          }
        }
      ]

    });	     
    $('.vartical-product-active a').on('click', function () {
      $('.vartical-product-active a').removeClass('active');
    });

    /*--
    vertical-product-active
--------------------------------------*/
    $('.horizantal-product-active').slick({
      slidesToShow: 4,
      autoplay: false,
      vertical:false,
      verticalSwiping:true,
      slidesToScroll: 1,
      prevArrow:'<i class="icon-arrow-top arrow-prv"></i>',
      nextArrow:'<i class="icon-arrow-bottom arrow-next"></i>',
      button:false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        { breakpoint: 991,
         settings: {
           slidesToShow: 3,
         }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
          }
        }
      ]

    });	     
    $('.horizantal-product-active a').on('click', function () {
      $('.horizantal-product-active a').removeClass('active');
    });



    /*--
    Magnific Popup
------------------------*/
    $('.img-poppu').magnificPopup({
      type: 'image',
      gallery:{
        enabled:true
      }
    });


/*--
    Accordion
-------------------------*/
  $(".faequently-accordion").collapse({
      accordion:true,
    open: function() {
      this.slideDown(300);
    },
    close: function() {
      this.slideUp(300);
    }		
  });	

    /* --
    counterUp 
-----------------------------*/
    $('.count').counterUp({
      delay: 10,
      time: 1000
    });

    /*--
    ScrollUp Active
-----------------------------------*/
    $.scrollUp({
      scrollText: '<i class="ion-chevron-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });   

  });
})(jQuery);	
